import axios from "axios";
export const createOrUpdateIdentity = data => {
  return axios.request({
    url: "/api/identity/createOrUpdate",
    method: "post",
    data
  });
};
export const getByIdentityId = () => {
  return axios.request({
    url: "/api/identity/getByIdentityId",
    method: "get",
    data: {}
  });
};
// 删除身份根据身份id
export const deleteByIdentityId = () => {
  return axios.request({
    url: "/api/identity/deleteByIdentityId",
    method: "get",
    data: {}
  });
};
// 分页查询身份列表
export const findIdentityPage = data => {
  return axios.request({
    url: "/api/identity/findPage",
    method: "get",
    data: data
  });
};
// 分配身份
export const assignIdentity = data => {
  return axios.request({
    url: "/api/identity/assignIdentity",
    method: "post",
    data: data
  });
};
// 删除用户身份
export const removeUserIdentity = data => {
  return axios.request({
    url: "/api/identity/removeUserIdentity",
    method: "get",
    params: data
  });
};
// 查询身份下面用户列表（包括部门）
export const identityUserRelationPage = params => {
  return axios.request({
    url: "/api/identity/identityUserRelationPage",
    method: "get",
    params
  });
};
// 单位数
export const getUnitTree = params => {
  return axios.request({
    url: "/api/gig/unit/tree",
    method: "get",
    params
  });
};
export default {
  createOrUpdateIdentity,
  getByIdentityId,
  deleteByIdentityId,
  findIdentityPage,
  assignIdentity,
  removeUserIdentity,
  identityUserRelationPage,
  getUnitTree
};